<template>
    <v-text-field
        dense=""
        v-model="info"
        @keyup="data(info, uid)"
        label="Enlace Externo Embebido"
        outlined
        rounded
    ></v-text-field>
</template>

<script>
export default {
    props: ["data", "uid", "content"],
    data() {
        return {
            info: this.content
        };
    },
    watch: {
        content() {
            this.info = this.content;
        }
    }
};
</script>

<style></style>
